import { Injectable } from "@angular/core";
import { IID_OL_SOLLECITO } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDolSollecitoStore } from "./iidOlSollecito.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.ORDINE_OLO)
export class IIDolSollecitoQuery extends AbstractInterfaceDataQuery<IID_OL_SOLLECITO> {
  constructor(protected store: IIDolSollecitoStore) {
    super(store);
  }
}
